import LazyImage from '../../../shared/Alerts/LazyImage';
const icons = {
  '1a': <LazyImage src="1/1.png" alt="Football" />,
  '1b': <LazyImage src="2/1.png" alt="Football" />,

  '2a': <LazyImage src="1/2.png" alt="Archery" />,
  '2b': <LazyImage src="2/2.png" alt="Archery" />,

  '3a': <LazyImage src="1/3.png" alt="Athletics" />,
  '3b': <LazyImage src="2/3.png" alt="Athletics" />,

  '4a': <LazyImage src="1/4.png" alt="Australian Rules Football" />,
  '4b': <LazyImage src="2/4.png" alt="Australian Rules Football" />,

  '5a': <LazyImage src="1/5.png" alt="Badminton" />,
  '5b': <LazyImage src="2/5.png" alt="Badminton" />,

  '6a': <LazyImage src="1/6.png" alt="Bandy" />,
  '6b': <LazyImage src="2/6.png" alt="Bandy" />,

  '7a': <LazyImage src="1/7.png" alt="Baseball" />,
  '7b': <LazyImage src="2/7.png" alt="Baseball" />,

  '8a': <LazyImage src="1/8.png" alt="Basketball" />,
  '8b': <LazyImage src="2/8.png" alt="Basketball" />,

  '9a': <LazyImage src="1/39.png" alt="Beach Handball" />,
  '9b': <LazyImage src="2/39.png" alt="Beach Handball" />,

  '10a': <LazyImage src="1/78.png" alt="Beach Soccer" />,
  '10b': <LazyImage src="2/78.png" alt="Beach Soccer" />,

  '11a': <LazyImage src="1/11.png" alt="Beach volleyball" />,
  '11b': <LazyImage src="2/11.png" alt="Beach volleyball" />,

  '12a': <LazyImage src="1/12.png" alt="Biathlon" />,
  '12b': <LazyImage src="2/12.png" alt="Biathlon" />,

  '13a': <LazyImage src="1/13.png" alt="Bobsleigh" />,
  '13b': <LazyImage src="2/13.png" alt="Bobsleigh" />,

  '14a': <LazyImage src="1/14.png" alt="Bowls" />,
  '14b': <LazyImage src="2/14.png" alt="Bowls" />,

  '15a': <LazyImage src="1/15.png" alt="Boxing" />,
  '15b': <LazyImage src="2/15.png" alt="Boxing" />,

  '16a': <LazyImage src="1/16.png" alt="Canoeing" />,
  '16b': <LazyImage src="2/16.png" alt="Canoeing" />,

  '17a': <LazyImage src="1/17.png" alt="Chess" />,
  '17b': <LazyImage src="2/17.png" alt="Chess" />,

  '18a': <LazyImage src="1/18.png" alt="Combat Sports" />,
  '18b': <LazyImage src="2/18.png" alt="Combat Sports" />,

  '19a': <LazyImage src="1/19.png" alt="Cricket" />,
  '19b': <LazyImage src="2/19.png" alt="Cricket" />,

  '20a': <LazyImage src="1/73.png" alt="Cross Country Skiing" />,
  '20b': <LazyImage src="2/73.png" alt="Cross Country Skiing" />,

  '21a': <LazyImage src="1/21.png" alt="Curling" />,
  '21b': <LazyImage src="2/21.png" alt="Curling" />,

  '22a': <LazyImage src="1/22.png" alt="Cycling" />,
  '22b': <LazyImage src="2/22.png" alt="Cycling" />,

  '23a': <LazyImage src="1/23.png" alt="Darts" />,
  '23b': <LazyImage src="2/23.png" alt="Darts" />,

  '24a': <LazyImage src="1/24.png" alt="Diving" />,
  '24b': <LazyImage src="2/24.png" alt="Diving" />,

  '25a': <LazyImage src="1/25.png" alt="Entertainment" />,
  '25b': <LazyImage src="2/25.png" alt="Entertainment" />,

  '26a': <LazyImage src="1/26.png" alt="Equestrian eSports" />,
  '26b': <LazyImage src="2/26.png" alt="Equestrian eSports" />,

  '27a': <LazyImage src="1/27.png" alt="Fencing" />,
  '27b': <LazyImage src="2/27.png" alt="Fencing" />,

  '28a': <LazyImage src="1/28.png" alt="Figure Skating" />,
  '28b': <LazyImage src="2/28.png" alt="Figure Skating" />,

  '29a': <LazyImage src="1/29.png" alt="Financials" />,
  '29b': <LazyImage src="2/29.png" alt="Financials" />,

  '30a': <LazyImage src="1/30.png" alt="Fistball" />,
  '30b': <LazyImage src="2/30.png" alt="Fistball" />,

  '31a': <LazyImage src="1/31.png" alt="Floorball" />,
  '31b': <LazyImage src="2/31.png" alt="Floorball" />,

  '32a': <LazyImage src="1/32.png" alt="Formula 1" />,
  '32b': <LazyImage src="2/32.png" alt="Formula 1" />,

  '33a': <LazyImage src="1/73.png" alt="Freestyle Skiing" />,
  '33b': <LazyImage src="2/73.png" alt="Freestyle Skiing" />,

  '34a': <LazyImage src="1/34.png" alt="Futsal" />,
  '34b': <LazyImage src="2/34.png" alt="Futsal" />,

  '35a': <LazyImage src="1/35.png" alt="Gaelic Sports" />,
  '35b': <LazyImage src="2/35.png" alt="Gaelic Sports" />,

  '36a': <LazyImage src="1/36.png" alt="Golf" />,
  '36b': <LazyImage src="2/36.png" alt="Golf" />,

  '37a': <LazyImage src="1/37.png" alt="Greyhounds" />,
  '37b': <LazyImage src="2/37.png" alt="Greyhounds" />,

  '38a': <LazyImage src="1/38.png" alt="Gymnastics" />,
  '38b': <LazyImage src="2/38.png" alt="Gymnastics" />,

  '39a': <LazyImage src="1/39.png" alt="Handball" />,
  '39b': <LazyImage src="2/39.png" alt="Handball" />,

  '40a': <LazyImage src="1/40.png" alt="Hockey" />,
  '40b': <LazyImage src="2/40.png" alt="Hockey" />,

  '41a': <LazyImage src="1/41.png" alt="Horses" />,
  '41b': <LazyImage src="2/41.png" alt="Horses" />,

  '42a': <LazyImage src="1/42.png" alt="Ice hockey" />,
  '42b': <LazyImage src="2/42.png" alt="Ice hockey" />,

  '43a': <LazyImage src="1/78.png" alt="Indoor Soccer" />,
  '43b': <LazyImage src="2/78.png" alt="Indoor Soccer" />,

  '44a': <LazyImage src="1/44.png" alt="Innebandy" />,
  '44b': <LazyImage src="2/44.png" alt="Innebandy" />,

  '45a': <LazyImage src="1/45.png" alt="Lacrosse" />,
  '45b': <LazyImage src="2/45.png" alt="Lacrosse" />,

  '46a': <LazyImage src="1/71.png" alt="Luge" />,
  '46b': <LazyImage src="2/71.png" alt="Luge" />,

  '47a': <LazyImage src="1/47.png" alt="Motocross" />,
  '47b': <LazyImage src="2/47.png" alt="Motocross" />,

  '48a': <LazyImage src="1/48.png" alt="MotorRacing" />,
  '48b': <LazyImage src="2/48.png" alt="MotorRacing" />,

  '49a': <LazyImage src="1/49.png" alt="Motorbikes" />,
  '49b': <LazyImage src="2/49.png" alt="Motorbikes" />,

  '50a': <LazyImage src="1/50.png" alt="Motorsport" />,
  '50b': <LazyImage src="2/50.png" alt="Motorsport" />,

  '51a': <LazyImage src="1/51.png" alt="NASCAR" />,
  '51b': <LazyImage src="2/51.png" alt="NASCAR" />,

  '52a': <LazyImage src="1/52.png" alt="Netball" />,
  '52b': <LazyImage src="2/52.png" alt="Netball" />,

  '53a': <LazyImage src="1/53.png" alt="Nordic Combined" />,
  '53b': <LazyImage src="2/53.png" alt="Nordic Combined" />,

  '54a': <LazyImage src="1/54.png" alt="Olympics Specials" />,
  '54b': <LazyImage src="2/54.png" alt="Olympics Specials" />,

  '55a': <LazyImage src="1/55.png" alt="Padel" />,
  '55b': <LazyImage src="2/55.png" alt="Padel" />,

  '56a': <LazyImage src="1/56.png" alt="Pelota" />,
  '56b': <LazyImage src="2/56.png" alt="Pelota" />,

  '57a': <LazyImage src="1/57.png" alt="Petanque (Lyonnaise Bowls)" />,
  '57b': <LazyImage src="2/57.png" alt="Petanque (Lyonnaise Bowls)" />,

  '58a': <LazyImage src="1/58.png" alt="Poker" />,
  '58b': <LazyImage src="2/58.png" alt="Poker" />,

  '59a': <LazyImage src="1/59.png" alt="Politics" />,
  '59b': <LazyImage src="2/59.png" alt="Politics" />,

  '60a': <LazyImage src="1/60.png" alt="Pool" />,
  '60b': <LazyImage src="2/60.png" alt="Pool" />,

  '61a': <LazyImage src="1/61.png" alt="Rally" />,
  '61b': <LazyImage src="2/61.png" alt="Rally" />,

  '62a': <LazyImage src="1/40.png" alt="Rink Hockey" />,
  '62b': <LazyImage src="2/40.png" alt="Rink Hockey" />,

  '63a': <LazyImage src="1/63.png" alt="Rowing" />,
  '63b': <LazyImage src="2/63.png" alt="Rowing" />,

  '64a': <LazyImage src="1/64.png" alt="Rugby" />,
  '64b': <LazyImage src="2/64.png" alt="Rugby" />,

  '65a': <LazyImage src="1/65.png" alt="Rugby League" />,
  '65b': <LazyImage src="2/65.png" alt="Rugby League" />,

  '66a': <LazyImage src="1/66.png" alt="Rugby Union" />,
  '66b': <LazyImage src="2/66.png" alt="Rugby Union" />,

  '67a': <LazyImage src="1/67.png" alt="Sailing" />,
  '67b': <LazyImage src="2/67.png" alt="Sailing" />,

  '68a': <LazyImage src="1/68.png" alt="Schwingen" />,
  '68b': <LazyImage src="2/68.png" alt="Schwingen" />,

  '69a': <LazyImage src="1/69.png" alt="Shooting" />,
  '69b': <LazyImage src="2/69.png" alt="Shooting" />,

  '70a': <LazyImage src="1/70.png" alt="Show Jumping" />,
  '70b': <LazyImage src="2/70.png" alt="Show Jumping" />,

  '71a': <LazyImage src="1/71.png" alt="Skeleton" />,
  '71b': <LazyImage src="2/71.png" alt="Skeleton" />,

  '72a': <LazyImage src="1/72.png" alt="Ski Jumping" />,
  '72b': <LazyImage src="2/72.png" alt="Ski Jumping" />,

  '73a': <LazyImage src="1/73.png" alt="Skialpine" />,
  '73b': <LazyImage src="2/73.png" alt="Skialpine" />,

  '74a': <LazyImage src="1/74.png" alt="Skinordic" />,
  '74b': <LazyImage src="2/74.png" alt="Skinordic" />,

  '75a': <LazyImage src="1/75.png" alt="Snooker" />,
  '75b': <LazyImage src="2/75.png" alt="Snooker" />,

  '76a': <LazyImage src="1/76.png" alt="Snowboarding" />,
  '76b': <LazyImage src="2/76.png" alt="Snowboarding" />,

  '77a': <LazyImage src="1/77.png" alt="SoftBall" />,
  '77b': <LazyImage src="2/77.png" alt="SoftBall" />,

  '78a': <LazyImage src="1/78.png" alt="Soccer" />,
  '78b': <LazyImage src="2/78.png" alt="Soccer" />,

  '79a': <LazyImage src="1/79.png" alt="Specials" />,
  '79b': <LazyImage src="2/79.png" alt="Specials" />,

  '80a': <LazyImage src="1/80.png" alt="Speed Skating" />,
  '80b': <LazyImage src="2/80.png" alt="Speed Skating" />,

  '81a': <LazyImage src="1/81.png" alt="Speedway" />,
  '81b': <LazyImage src="2/81.png" alt="Speedway" />,

  '82a': <LazyImage src="1/82.png" alt="Squash" />,
  '82b': <LazyImage src="2/82.png" alt="Squash" />,

  '83a': <LazyImage src="1/83.png" alt="Swimming" />,
  '83b': <LazyImage src="2/83.png" alt="Swimming" />,

  '84a': <LazyImage src="1/84.png" alt="Table Soccer" />,
  '84b': <LazyImage src="2/84.png" alt="Table Soccer" />,

  '85a': <LazyImage src="1/85.png" alt="Table Tennis" />,
  '85b': <LazyImage src="2/85.png" alt="Table Tennis" />,

  '86a': <LazyImage src="1/86.png" alt="Ten-Pin Bowling" />,
  '86b': <LazyImage src="2/86.png" alt="Ten-Pin Bowling" />,

  '87a': <LazyImage src="1/87.png" alt="Tennis" />,
  '87b': <LazyImage src="2/87.png" alt="Tennis" />,

  '88a': <LazyImage src="1/88.png" alt="Triathlon" />,
  '88b': <LazyImage src="2/88.png" alt="Triathlon" />,

  '89a': <LazyImage src="1/89.png" alt="Trotting" />,
  '89b': <LazyImage src="2/89.png" alt="Trotting" />,

  '90a': <LazyImage src="1/39.png" alt="Volleyball" />,
  '90b': <LazyImage src="2/39.png" alt="Volleyball" />,

  '91a': <LazyImage src="1/91.png" alt="Water Polo" />,
  '91b': <LazyImage src="2/91.png" alt="Water Polo" />,

  '92a': <LazyImage src="1/92.png" alt="Weight Lifting" />,
  '92b': <LazyImage src="2/92.png" alt="Weight Lifting" />,

  '93a': <LazyImage src="1/93.png" alt="eSports" />,
  '93b': <LazyImage src="2/93.png" alt="eSports" />
};

export default icons;